module.exports = __webpack_public_path__ + "static/media/03-final.523ca423.webp";